import api from './api';

export const authService = {
  async login(credentials) {
    try{
      const response = await api.post('/auth/reslogin', credentials);
      console.log("Response Data => ", response.data)
      localStorage.setItem("user_id",response.data.user.id)
      return response.data;
    }
    catch(error){
      // console.error("Error Here ",error)
      throw new Error(error)
    }
    
  },


  async logout() {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    }
  },

  async refreshToken(refreshToken) {
    const response = await api.post('/auth/refresh', {
      refresh_token: refreshToken,
    });
    return response.data;
  },

  async getCurrentUser() {
    const response = await api.get('/auth/me');
    return response.data;
  },
};
